import { createContext, useContext, useState } from 'react';
import { themes } from './theme';

const ThemeContext = createContext(null);

function getInitialThemeName() {
  const stored = localStorage.getItem('wtgl_theme');
  if (stored && themes[stored]) return stored;
  const env = process.env.REACT_APP_THEME;
  if (env && themes[env]) return env;
  return 'default';
}

export function ThemeProvider({ children }) {
  const [activeThemeName, setActiveThemeName] = useState(getInitialThemeName);

  const setThemeName = (name) => {
    if (!themes[name]) return;
    localStorage.setItem('wtgl_theme', name);
    setActiveThemeName(name);
  };

  return (
    <ThemeContext.Provider value={{ theme: themes[activeThemeName], themeName: activeThemeName, setThemeName }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
